import { useEffect, useState } from "react"

const TouchUpdateInputField = ({ value, onChange, type, textarea = false }) => {

  const [defaultValue, setDefaultValue] = useState("")
  useEffect(() => {
    setDefaultValue(value)
  }, [value])

  const updateFieldValue = (newValue) => {
    if (type != 'number' || newValue == "") {
      setDefaultValue(newValue);
    } else {
      if (!isNaN(newValue)) {
        setDefaultValue(newValue)
      }
    }
  }
  const [showInput, setShowInput] = useState(false)
  return <div className="max-w-48 w-full h-full">{
    showInput ? textarea ? <textarea
      value={defaultValue || ""}
      onChange={(e) => { updateFieldValue(e.target.value) }}
      onBlur={() => {
        setShowInput(false);
        if (defaultValue != value)
          onChange(defaultValue);
      }}
      className='w-full bg-slate-50 border-2 px-0.5 rounded outline-none max-w-80 text-wrap min-h-28 '
    /> : <input
      value={defaultValue || ""}
      onChange={(e) => { updateFieldValue(e.target.value) }}
      onBlur={() => {
        setShowInput(false);
        if (defaultValue != value)
          onChange(defaultValue);
      }}
      className='w-full bg-slate-50 border rounded outline-none max-w-80 text-wrap '
    />
      : <button className="w-full h-full hover:bg-slate-100 max-w-80 text-wrap overflow-auto" onClick={() => setShowInput(true)}>{value ? value : 'no value'}</button>
  }</div>

}

export default TouchUpdateInputField;
